import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'src/app/services/cache.service';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
  username: any;
  constructor(private cacheService: CacheService ,private router: Router ,public translate: TranslateService,
    private iconRegistry: MatIconRegistry ,private sanitizer: DomSanitizer) { 
    iconRegistry.addSvgIcon('power_settings', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/power_settings.svg'));
  }

  ngOnInit(): void {
    this.username=this.cacheService.getItem('username');
  }

  changeLang(language: string) {  
    this.cacheService.setItem('locale', language);
    this.translate.use(language);  
  } 
  logout() {
    this.cacheService.clear();
    this.router.navigate(["login"]);
  }
}
